<template>
  <v-container grid-list-lg id="regFormContainer">
    <v-layout justify-center>
      <v-flex md8>
        <v-card>
          <v-form ref="form">
            <v-card-title>
              <h2>REGISTER NOW!</h2>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-layout wrap>
                  <v-flex md6>
                    <p>
                      If you're interested to know more about our programs,
                      please feel free to reach out!
                    </p>
                  </v-flex>
                  <v-flex xs12>
                    <strong class="mb-3">Basic Details</strong>
                    <v-subheader class="primary--text">
                      <strong
                        ><em
                          >* Please select first your country of origin. Kindly
                          provide your complete name that appears on your
                          professional ID..</em
                        ></strong
                      >
                    </v-subheader>
                  </v-flex>
                  <v-flex md4>
                    <v-select
                      label="Country"
                      v-model="country"
                      :items="countries"
                      item-value="value"
                      item-text="label"
                      :rules="[(v) => !!v || 'country is required']"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex md4 v-if="country === 'Malaysia'">
                    <v-text-field
                      label="Full Name"
                      v-model="wholeName"
                      :rules="wholeNameRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4 v-if="country !== 'Malaysia'">
                    <v-text-field
                      label="Last Name"
                      v-model="lastName"
                      :rules="lastNameRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4 v-if="country !== 'Malaysia'">
                    <v-text-field
                      label="First Name"
                      v-model="firstName"
                      :rules="firstNameRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4 v-if="country !== 'Malaysia'">
                    <v-text-field
                      label="Middle Name"
                      v-model="middleName"
                    ></v-text-field>
                  </v-flex>
                  <!--<v-flex md4>
                    <v-text-field
                      type="date"
                      label="Birthday"
                      v-model="birthday"
                      prepend-icon="cake"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      label="Primary Contact Number"
                      v-model="primaryContactNumber"
                      mask="#(###) ### - ####"
                      prepend-icon="phone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      label="Secondary Contact Number"
                      v-model="secondaryContactNumber"
                      mask="phone"
                      prepend-icon="phone"
                    ></v-text-field>
                  </v-flex>-->
                  <v-flex md4>
                    <v-select
                      label="Specialization"
                      v-model="specialization"
                      :items="specialtyList"
                      item-value="value"
                      item-text="label"
                      :rules="[(v) => !!v || 'Specialization is required']"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      label="Email Address"
                      v-model="emailAddress"
                      :rules="emailRules"
                      required
                      prepend-icon="email"
                    ></v-text-field>
                  </v-flex>
                  <!--<v-flex md4>
                    <v-text-field
                      label="Other Contact details"
                      v-model="otherContactDetails"
                      mask="phone"
                      prepend-icon="phone"
                    ></v-text-field>
                  </v-flex>-->
                </v-layout>

                <!--<v-layout
                  wrap
                  v-if="country === 'Philippines' || country === ''"
                >-->
                <v-layout wrap>
                  <v-flex xs12>
                    <strong class="mb-3">PRC Registration</strong>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      label="PRC Number"
                      v-model="prcNumber"
                      :rules="prcNumberRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      label="Date of PRC Registration"
                      type="date"
                      v-model="prcRegistrationDate"
                      :rules="prcRegistrationDateRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      label="Valid Until"
                      type="date"
                      v-model="prcValidity"
                      :rules="prcValidityRules"
                      required
                    ></v-text-field
                    >``
                  </v-flex>
                </v-layout>

                <!--<v-layout wrap v-if="country !== 'Philippines'">
                  <v-flex md4>
                    <v-text-field
                      :label="
                        country === 'Malaysia'
                          ? 'MMC or MPS number'
                          : 'MCR Number'
                      "
                      v-model="mcrNumber"
                      :rules="mcrNumberRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4 v-if="country === 'Malaysia'">
                    <v-text-field
                      label="IC Number"
                      v-model="icNumber"
                      :rules="icNumberRules"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>-->

                <v-layout>
                  <v-flex>
                    <v-checkbox v-model="agreePolicy" :rules="agreePolicyRules">
                      <div slot="label">
                        I agree to the site's
                        <a @click.stop="showPrivacyPolicyDialog"
                          >Privacy Statement and Terms of Use.</a
                        >
                      </div>
                    </v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <label style="color: rgba(0, 0, 0, 0.54)"
                      >By clicking below, I agree to be notified through email
                      for any updates on this program.</label
                    >
                  </v-flex>
                </v-layout>
                <!--
                <v-layout>
                  <v-container>
                    <v-flex>
                      <v-checkbox
                        v-model="notifyToMobile"
                        label="Mobile"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                  </v-container>
                </v-layout>
                -->
                <v-layout v-if="notifyToMobile">
                  <v-container>
                    <v-flex xs12 md5>
                      <v-text-field
                        label="Mobile Number"
                        v-model="mobileNumberInputField"
                        mask="#### ### - ####"
                        prepend-icon="phone"
                      ></v-text-field>
                    </v-flex>
                  </v-container>
                </v-layout>
                <v-layout>
                  <v-container>
                    <v-flex>
                      <v-checkbox
                        v-model="notifyToEmail"
                        label="Email"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                  </v-container>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-layout align-center justify-center>
                <v-flex xs6 text-xs-center>
                  <v-btn
                    @click="submit"
                    color="primary"
                    :disabled="!submitbutton"
                    >Submit</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="privacyPolicyDialog" max-width="800">
      <v-card>
        <v-card-title>
          <div class="headline">Terms of Use and Privacy Statement</div>
        </v-card-title>
        <v-card-text>
          <section>
            <ol>
              <li>
                <strong class="accent--text"
                  >MERCK, INC. General Terms and Conditions.</strong
                >
              </li>
              <p>
                Access to and use of this website are both subject to the
                following conditions. Should you disagree with these conditions,
                please do not use this website.
              </p>
              <p>
                This website is operated by IPADAMA 360 INC., a service provider
                of Merck, Inc. (hereinafter also “Merck”, “we”, “us” or “our”).
              </p>
              <p>
                This website is for general informational and educational
                purposes only and, although it may be available in different
                languages, it is not country specific. By using this website you
                declare that you use it and its content at your own risk.
              </p>
              <p>
                Under no circumstances may this website or its contents may be
                used or understood as a substitute for healthcare professional
                advice and is not to be used for diagnosis of any health problem
                or disease. Patients should always consult a doctor or another
                healthcare professional for medical advice or information about
                diagnosis and treatment. If your situation is serious, always
                call the emergency service.
              </p>
              <li>
                <strong class="accent--text">1. Exclusion of liability</strong>
              </li>
              <p>
                We have compiled the content of this website carefully and in
                accordance with the current state of knowledge. However, we give
                no warranty, neither expressly nor tacitly, for the completeness
                or correctness of the details provided on this website. Please
                be aware, in particular, that the details we provide may no
                longer be up-to-date.
              </p>
              <p>
                Access to and use of this website and of any associated sites or
                sites connected via links take place at the user’s own risk. We
                accept no liability for loss, damage or compensation claims due
                to missing or incorrect details. The Website and any services
                available through it are available solely for the User's
                personal and not for commercial use.
              </p>
              <li>
                <strong class="accent--text">2. Legal notes</strong>
              </li>
              <p>
                All rights to the website or arising from the same shall remain
                with Merck, Inc. or its affiliates.
              </p>
              <p>
                We may modify this website and/or discontinue its operation at
                any time without prior announcement, either wholly or in parts,
                at ourits own discretion and without accepting liability.
                Neither is Merck, under an obligation to update the content of
                this website.
              </p>
              <p>
                Unless otherwise indicated, all details, documents and
                presentations published on our website are under the sole
                ownership of Merck, Inc., its affiliates or third parties that
                have authorized its use. Unless written consent has been
                obtained from us, no permission is given to import published and
                copyrighted content from our website to other programs or
                website or to use such content in any other way.
              </p>
              <p>
                Access to this website is public and does not require
                registration. Please, be aware that users may be subject to
                provisions under local legislation. International users must
                observe the special provisions under local legislation. Users in
                the United States are subject to the conditions of use for the
                websites of our U.S. companies.
              </p>
              <li>
                <strong class="accent--text">3. Personal data</strong>
              </li>
              <p>
                We are concerned to ensure the protection of your personal data.
                You will find information on the use of personal data in the
                Privacy Statement.
              </p>
              <li>
                <strong class="accent--text">4. Content</strong>
              </li>
              <p>
                This website may contain general information regarding medical
                conditions. Such information is provided for informational
                purposes only, under no circumstances may it be used or
                understood as a substitute for healthcare professional advice
                and is not to be used for diagnosis of any health problem or
                disease. Patients should always consult a doctor or another
                healthcare professional for medical advice or information about
                diagnosis and treatment.
              </p>
              <p>
                The website may also include links to third-party websites. Such
                links are provided merely as a convenience. The content of
                third-party web sites is beyond our control and we make no
                warranties or representations regarding the accuracy or validity
                of such information. Neither do the links represent any kind of
                support or endorsement of the linked website's contents. Access
                to and use of sites connected via links take place at the user’s
                own risk.
              </p>
              <p>As of: April 2024</p>
            </ol>
          </section>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.stop="privacyPolicyDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="notificationResponse" max-width="600">
      <v-card>
        <v-card-text>
          <h2 class="text-xs-center">Congratulations!</h2>
          <h3 class="text-xs-center">{{ text }}</h3>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar bottom color="info" v-model="snackbar">
      {{ text }}
      <v-btn flat color="pink" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import PrivacyPolicy from "@/components/profile/privacyPolicy";
import config from "../../../configApi";
const API_URL = config.apiUrl;

export default {
  components: {
    PrivacyPolicy,
  },
  data() {
    return {
      mobileNumberInputField: null,
      snackbar: false,
      text: "",
      privacyPolicyDialog: false,
      notificationResponse: false,
      firstName: "",
      lastName: "",
      wholeName: "",
      middleName: "",
      nickname: "",
      birthday: "",
      primaryContactNumber: "",
      secondaryContactNumber: "",
      emailAddress: "",
      password: "",
      otherContactDetails: "",
      prcNumber: "",
      mcrNumber: "",
      icNumber: "",
      prcRegistrationDate: "",
      prcValidity: "",
      firstNameRules: [(v) => !!v || "First Name is required"],
      lastNameRules: [(v) => !!v || "Last Name is required"],
      wholeNameRules: [(v) => !!v || "Name is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      passwordRules: [(v) => !!v || "Password is required"],
      prcNumberRules: [(v) => !!v || "PRC Number is required"],
      mcrNumberRules: [(v) => !!v || "MCR Number is required"],
      icNumberRules: [(v) => !!v || "IC Number is required"],
      prcRegistrationDateRules: [(v) => !!v || "This field is required"],
      prcValidityRules: [(v) => !!v || "This field is required"],
      agreePolicy: false,
      agreePolicyRules: [
        (v) =>
          !!v ||
          "You must agree to continue! Please check details if all are correct.",
      ],
      agreeToNotify: true,
      notifyToEmail: true,
      notifyToMobile: false,
      submitbutton: true,

      specialization: "",
      specialtyList: [
        { label: "Anesthesiology", value: "Anesthesiology" },
        { label: "Dermatology", value: "Dermatology" },
        { label: "Cardiology", value: "Cardiology" },
        { label: "Endocrinology", value: "Endocrinology" },
        { label: "Emergency Medicine", value: "Emergency Medicine" },
        { label: "Family Medicine", value: "Family Medicine" },
        { label: "GP", value: "gp" },
        { label: "Internal Medicine", value: "Internal Medicine" },
        { label: "Neurology", value: "Neurology" },
        {
          label: "Obstetrics and Gynecology",
          value: "Obstetrics and Gynecology",
        },
        { label: "Occupational Medicine", value: "Occupational Medicine" },
        { label: "Otolaryngology", value: "Otolaryngology" },
        { label: "Ophthalmology", value: "Ophthalmology" },
        { label: "Pathology", value: "Pathology" },
        { label: "Pediatrics", value: "Pediatrics" },
        { label: "Psychiatry", value: "Psychiatry" },
        { label: "Radiology", value: "Radiology" },
        { label: "Surgery", value: "Surgery" },
        { label: "Others", value: "Others" },
      ],
      countries: [
        { label: "Philippines", value: "Philippines" },
        // { label: "Malaysia", value: "Malaysia" }
      ],
      country: { label: "Philippines", value: "Philippines" },
    };
  },
  watch: {
    notifyToMobile(val) {
      if (val) {
      }
    },
  },
  methods: {
    showPrivacyPolicyDialog() {
      this.privacyPolicyDialog = true;
    },
    submit(e) {
      this.submitForm();
    },
    submitForm() {
      if (this.$refs.form.validate()) {
        var data = {
          firstname: this.firstName,
          lastname: this.lastName,
          middlename: this.middleName,
          nickname: this.nickname,
          birthdate: this.birthday,
          email: this.emailAddress,
          password: this.password,
          // phone_numbers: [
          //   {
          //     type: 'primary contact number',
          //     number: this.primaryContactNumber
          //   },
          //   {
          //     type: 'secondary contact number',
          //     number: this.secondaryContactNumber
          //   },
          //   {
          //     type: 'other contact number',
          //     number: this.otherContactDetails
          //   }
          // ],
          phone_numbers: [
            {
              type: "primary contact number",
              number: this.mobileNumberInputField,
            },
          ],
          prc_number: this.prcNumber,
          registration_date: this.prcRegistrationDate,
          valid_until: this.prcValidity,
          notify_to_email: this.notifyToEmail,
          notify_to_mobile: this.notifyToMobile,
          specialty: this.specialization,
          country: this.country,
          name: this.wholeName,
          mcr_number: this.mcrNumber,
          ic_number: this.icNumber,
        };
        var formData = new FormData();
        for (var prop in data) {
          if (Array.isArray(data[prop])) {
            data[prop].map((obj) => {
              formData.append(`${prop}[]`, JSON.stringify(obj));
            });
          } else {
            formData.set(`${prop}`, `${data[prop]}`);
          }
        }
        this.submitbutton = false;
        // Native form submission is not yet supported
        axios
          .post(API_URL + "/user/registration", formData)
          .then((e) => {
            this.notification();
            // this.$router.push('/login')
            this.submitbutton = true;
            this.$refs.form.reset();
          })
          .catch((e) => {
            this.text = JSON.stringify(e.response.data);
            this.text = "email has already been taken";
            this.snackbar = true;
            this.submitbutton = true;
          });
      }
    },
    notification() {
      this.text =
        "A message has been sent to your email to verify your registration";
      // this.snackbar = true
      this.notificationResponse = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/registration.vue